import { NewSceneController } from "./NewSceneController"

/**
 * Opens the new scene form in an overlayf
 * @param options optional config block
 * @param options.device the relevant device - if passed, this device will be selected in the UI on mount
 */
export const openNewSceneOverlay = NewSceneController.openNewSceneOverlay
